module.exports = __webpack_public_path__ + "img/baby-chick.000c7517.png";